import React from 'react'
import { Button, notification } from 'antd'
import { CopyOutlined } from '@ant-design/icons'
import { OrderData } from '../../../../services/api/orders'
import { safePrintValue } from '../../../../utils'
import { displayAmount, displayDatetime } from '../../../../utils/formatter'
import { useSecurity } from '../../../../services/security'

const MESSAGE_SEPARATOR = '\n'

type Props = {
  order: OrderData
}

export const CopyOrderData: React.FunctionComponent<Props> = ({ order }) => {
  const { isSecured: isAvailable } = useSecurity()

  const copyOrderData = () => {
    const message: string = [
      `Provider: ${safePrintValue(order.provider)}`,
      `PCC: ${safePrintValue(order.pcc)}`,
      `PNR GDS: ${safePrintValue(order.providerPnr)}`,
      `PNR АК: ${safePrintValue(order.pnr)}`,
      '',
      `Creating date: ${displayDatetime(order.createdAt)} (местное время)`,
      `Cost: ${displayAmount(order.priceAmount)}`,
      '',
      `Order_id: ${order.id}`,
      `Kupi_uuid: ${order.kupiOrderUuid}`,
    ].join(MESSAGE_SEPARATOR)

    navigator.clipboard.writeText(message)
    notification.info({
      message: 'Данные скопированы',
      duration: 3,
    })
  }

  return (
    <Button type="primary" onClick={copyOrderData} disabled={!isAvailable}>
      <CopyOutlined />
      Скопировать данные
    </Button>
  )
}
